// extracted by mini-css-extract-plugin
export default {"image":"FadeInImage_image__hh3lv","loaded":"FadeInImage_loaded__8J8eu"};